<script>
    import Image from "./Image.svelte";
    import Button from "./Button.svelte";

    export let data;
    let isCollapsed = false;

    function change(val, section) {
        data.style = Object.assign({}, data.style, {[section]: val});
    }

    function onCollapse(collapsed) {
        isCollapsed = collapsed;
    }
</script>

<Image bind:data={data} disable={['link', 'fullscreen']} isCollapsable={true} onCollapse={onCollapse}/>
<Button bind:data={data} disable={['align']} isCollapsable={true} onCollapse={onCollapse}/>
